import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import store from 'STORE';
import routes from 'ROUTE/routerDom';

const APPReact = document.getElementById('app');
ReactDOM.render(
  <Provider store={store}>
    <Router history={browserHistory}>
      <Route
        path={routes.hfive.path}
        component={routes.hfive.component}
        indexRoute={routes.hfive.indexRoute}
        childRoutes={routes.hfive.childRoutes}
      />
    </Router>
  </Provider>,
  APPReact,
);



// WEBPACK FOOTER //
// ./src/app.js